export const TOPBAR_ENDPOINT =
  process.env.TOPBAR_ENDPOINT || 'https://www.jusbrasil.com.br/topbar/v3/'
export const TOPBAR_LAZY_RELATIVE_PATH = process.env.TOPBAR_LAZY_RELATIVE_PATH || '/topbar/v3/'
export const TOPBAR_INTERNAL_DATA = '__TOPBAR_DATA__'
